<template>
  <div>
    <Banner />
    <section class="hero">
      <div>
        <h2>联系客服</h2>
        <div class="container">
          <!-- <div class="left">
            <p>如有任何问题，请于 PositiveGrid 微信公众号留言，我们会尽快给予回复。谢谢！</p>
            <div class="wechat">
              <img
                style="width: 60px; height: 60px;"
                src="@/assets/footer/wechat-logo@2x.png"
              >
              <div class="search-text">
                <h4>微信搜索并关注</h4>
                <p>PositiveGrid</p>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/footer/wechat-qr@2x.png">
          </div> -->
          <div class="text">
            1. 如果对我们的产品使用有疑问，可以点击这里<a @click="toPage">【帮助中心】
            </a>获得基本功能的使用说明
          </div>
          <div class="text">
            2. 如果在帮助中心您无法找到解决的方法，可以登录我们的天猫期舰店Positive Grid，寻求在线客服的帮助
            时间：早上9点-晚上12点（节假日不间断）
          </div>
        </div>
      </div>
    </section>
    <footer-common />
  </div>
</template>

<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  name: 'Index',
  components: { Banner, FooterCommon },
  data () {
    return {}
  },
  computed: {},
  mounted: function () {},
  methods: {
    toPage () {
      this.$router.push('/help-center')
    }
  }
}
</script>

<style scoped>
* {
    font-weight: 300;
}
section.hero > img {
    max-height: 440px;
    background-size: cover;
    width: 100%;
}
section.hero {
    margin-top: 40px;
}
section.hero > div {
    text-align: left;
}
section.hero > div > h3 {
    margin: 0;
}

.artists {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.artists > a {
    flex-grow: 1;
    width: 40%;
    position: relative;
    margin: 5%;
}

.desc {
    position: absolute;
    bottom: 0;
    height: 26%;
    width: 100%;
    background-color: black;
    opacity: 0.8;
    padding-left: 5%;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.desc > * {
    padding: 0;
    margin: 0;
    color: white;
}

.desc > h4 {
    font-size: 24px;
}
.desc > p {
    font-size: 14px;
}
.desc > a {
    font-size: 16px;
}

.artists > a > img {
    max-width: 100%;
    max-height: 100%;
}

section.hero {
    background-image: url(../assets/footer.jpg);
    min-height: calc(100vh - 304px);
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-weight: 600;
    color: white;
}

section.hero h2,
section.hero h4 {
    padding: 0;
    margin: 0;
}
@media screen and (max-width: 768px) {
    section.hero {
        min-height: calc(100vh - 304px);
        background-position: center top;
        background-size: cover;
        overflow: hidden;
    }
    .artists {
        width: 95%;
    }
    .artists > a {
        width: 90%;
        margin: 5%;
    }
}
h4 {
    color: #64ab22;
    font-size: 20px;
}

.container .text {
    font-size: 20px;
    text-align: left;
    text-align: justify
}
.container .text a {
    color: red;
}

.wechat {
    display: flex;
    flex-direction: row;
    height: 60px;
}
.right div {
    display: inline-block;
    max-height: 142px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    object-fit: contain;
}
.right img {
    max-height: 142px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    object-fit: contain;
}
.search-text {
    height: 100%;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    text-align: left;
    margin-left: 1rem;
}
.search-text > * {
    margin: 0;
}
h2 {
    text-align: left;
}
.left > p {
    max-width: 350px;
}
.left {
    width: 70%;
    float: left;
}
.right {
    width: 30%;
    float: right;
}
@media screen and (max-width: 768px) {
    h2 {
        text-align: center;
    }
    .wechat {
        justify-content: center;
    }
    .container {
        text-align: center;
        display: flex;
        flex-direction: column;
    }
    .left {
        width: 100%;
        clear: both;
    }
    .right {
        width: 100%;
        clear: both;
        padding-top: 1rem;
    }
    .right img {
        height: 100px;
        width: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/support.vue